import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2962fe92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "security-info" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Sign in with email", -1))
const _hoisted_4 = {
  key: 0,
  class: "badge text-bg-success"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Sign in with an auth code", -1))
const _hoisted_7 = {
  key: 1,
  class: "generate-code"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Sign in codes", -1))
const _hoisted_9 = { class: "input-area" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  key: "default",
  value: 0
}, "Default lifetime", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "code-value"
}

import { computed, ref, watch } from 'vue'
import { useUserStore } from '@/gp/UserStore'
import { useIdentityApi, SignInCode, UserIdentity } from '@/auth/IdentityApi'
import { LoadMode } from '@/util/AsyncData';
import { UserPrivilege, useTokenManager } from '@/auth/TokenManager';
import { Duration } from 'luxon';
import { DateTimeUtil } from '@/util/LuxonUtil';
import AuthCode from '@/auth/AuthCode.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SecurityInfo',
  props: {
  userId: String,
},
  setup(__props) {

const props = __props;



const identityApi = useIdentityApi()
const userStore = useUserStore()
const tokenManager = useTokenManager()

const userRef = computed(() => userStore.getAsyncUser(props.userId, LoadMode.EnsureLoaded)?.data)
const isSelfRef = computed(() => props.userId == tokenManager.current.userId)
const identityRef = ref<UserIdentity | undefined>(undefined)
const showGenerateCodeRef = computed(() => tokenManager.current.hasPrivilege(UserPrivilege.ImpersonateUser) && userRef.value?.email?.startsWith('apptest@'));
const codeLifetimeRef = ref(0)
const codeLifetimeOptions = [1, 2, 3, 4, 5, 7, 10, 14]
const codeRef = ref<SignInCode | undefined>(undefined)

watch(userRef, async () => {
  if (userRef.value) {
    identityRef.value = await identityApi.getIdentityAsync(userRef.value.subject!)
  }
}, { immediate: true })

async function generateCode() {
  if (userRef.value) {
    const lifetime = codeLifetimeRef.value ? Duration.fromObject({ days: codeLifetimeRef.value }) : undefined
    codeRef.value = await identityApi.generateSignInCodeAsync(userRef.value.subject!, lifetime)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (identityRef.value)
      ? (_openBlock(), _createElementBlock("form", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(identityRef.value.addresses, (a) => {
              return (_openBlock(), _createElementBlock("div", {
                key: a.address,
                class: "input-value"
              }, [
                _createTextVNode(_toDisplayString(a.address) + " ", 1),
                (a.verifiedDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Verified"))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (isSelfRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(AuthCode, { "always-show-timer": "" })
              ]))
            : _createCommentVNode("", true),
          (showGenerateCodeRef.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((codeLifetimeRef).value = $event))
                  }, [
                    _hoisted_10,
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(codeLifetimeOptions, (o) => {
                      return _createElementVNode("option", {
                        key: o,
                        value: o
                      }, _toDisplayString(o) + " days", 9, _hoisted_11)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, codeLifetimeRef.value]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-warning",
                    onClick: generateCode
                  }, "Get code")
                ]),
                (codeRef.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(codeRef.value.code) + " (expires in " + _toDisplayString(_unref(DateTimeUtil).toRelativeFutureDate(codeRef.value.expirationDate)) + ")", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})